module.exports = __webpack_public_path__ + "static/media/restricted.74b2c1fe.svg";